import styled from '@emotion/styled';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Save from '@material-ui/icons/Save';
import Undo from '@material-ui/icons/Undo';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonWithIcon from '../../../../component/primitive/ButtonWithIcon';
import { SPACING_LARGE, SPACING_REGULAR, SPACING_UNIT } from '../../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../../styleUtility/flexibleLayout';
import mq from '../../../../styleUtility/mediaquery';

type Props = {
  saveAndGoBack: () => void;
  saveAndGoForward: () => void;
  saveAndGoToProjectList: () => void;
};

const DueActions: FC<Props> = ({ saveAndGoBack, saveAndGoForward, saveAndGoToProjectList }) => {
  return (
    <Actions>
      <Buttons>
        <ButtonWithIcon icon={Undo} color="default" variant="contained" onClick={saveAndGoBack}>
          <FormattedMessage id="project_editing_page.due_setting.buttons.back" />
        </ButtonWithIcon>
        <ButtonWithIcon icon={Save} color="default" variant="contained" onClick={saveAndGoToProjectList}>
          <FormattedMessage id="project_editing_page.due_setting.buttons.save_as_draft" />
        </ButtonWithIcon>
        <ButtonWithIcon icon={ArrowForward} variant="contained" color="primary" onClick={saveAndGoForward}>
          <FormattedMessage id="project_editing_page.due_setting.buttons.go_forward" />
        </ButtonWithIcon>
      </Buttons>
    </Actions>
  );
};

const Actions = styled('div')`
  ${flexibleLayoutContainer({
    justifyContent: 'flex-end',
  })}
  margin-top: ${SPACING_LARGE}px;
`;

const Buttons = styled('div')`
  > button {
    margin-left: ${SPACING_UNIT}px;
  }

  ${mq('sp')} {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin-top: ${SPACING_REGULAR}px;

    > button {
      margin-bottom: ${SPACING_UNIT}px;
      margin-left: 0;
    }
  }
`;

export default DueActions;
